import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { Heading } from 'vet-bones/design-system/components';

import { LAUNCHPAD_SDU_DASHBOARD_HEADING } from 'src/ui/constants/testIds';
import { SduDashboardBody } from 'src/ui/containers/sdu-dashboard/SduDashboardBody';
import { graphQLClient } from 'src/ui/graph/graphQLClient';
import { Connection, useSavedConnectionsQuery } from 'src/ui/graph/types';
import * as copy from 'src/ui/templates/copy';

export const LaunchpadSduDashboard: React.VFC = () => {
  const history = useHistory();

  const { data } = useSavedConnectionsQuery(graphQLClient, {});

  const connections: Connection[] = (data?.listConnections ?? []).filter(
    (c): c is NonNullable<typeof c> => c !== null
  );

  return (
    <div className="organization-dashboard">
      <div className="organization-dashboard-header">
        <div className="organization-dashboard-header-info">
          <Heading
            size="xl"
            testId={LAUNCHPAD_SDU_DASHBOARD_HEADING}
            weight="semibold"
          >
            {copy.components.sduDashboard.title}
          </Heading>
        </div>
      </div>
      <SduDashboardBody
        connections={connections}
        onEndpointClick={(row) => {
          history.push(`/units/${row.endpointId}`);
        }}
      />
    </div>
  );
};
